import React, { useState } from "react";
import { Mail, Pencil } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const inputCls = "px-3 py-2 rounded-md border border-zinc-300 bg-white text-sm text-zinc-900 focus:outline-none focus:ring-2 focus:ring-blue-600 w-full sm:w-56";

// Contactpersoon van een locatie-account: expliciet OPSLAAN (geen auto-save).
export function ContactEditor({ user, onSaved }) {
  const [open, setOpen] = useState(false);
  const [naam, setNaam] = useState("");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const u = user.username;

  const start = () => { setNaam(user.contactNaam || ""); setEmail(user.contactEmail || ""); setOpen(true); };
  const save = async () => {
    setBusy(true);
    try {
      await api.patch(`/users/${encodeURIComponent(u)}/contact`, { contactNaam: naam, contactEmail: email });
      toast.success("Contactpersoon opgeslagen");
      setOpen(false);
      onSaved?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Opslaan mislukt");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="basis-full flex flex-wrap items-center gap-2 pl-6 text-sm" data-testid={`contact-${u}`}>
      <Mail className="h-4 w-4 text-zinc-400" />
      {!open && (
        <>
          <span data-testid={`contact-naam-${u}`} className="text-zinc-700">{user.contactNaam || <span className="italic text-zinc-400">Geen naam</span>}</span>
          {user.contactEmail
            ? <span data-testid={`contact-email-${u}`} className="font-mono text-xs text-zinc-500 break-all">{user.contactEmail}</span>
            : <span data-testid={`contact-geen-email-${u}`} className="text-xs font-semibold text-amber-700">Geen e-mailadres</span>}
          <button data-testid={`contact-bewerken-${u}`} onClick={start} className="flex items-center gap-1 text-xs font-semibold text-blue-700 hover:underline">
            <Pencil className="h-3 w-3" /> Bewerken
          </button>
        </>
      )}
      {open && (
        <>
          <input data-testid={`contact-naam-input-${u}`} maxLength={80} placeholder="Naam bedrijfsleider" value={naam} onChange={(e) => setNaam(e.target.value)} className={inputCls} />
          <input data-testid={`contact-email-input-${u}`} type="email" maxLength={200} placeholder="E-mailadres bedrijfsleider" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} />
          <button data-testid={`contact-opslaan-${u}`} disabled={busy} onClick={save} className="px-3 py-2 rounded-md bg-zinc-950 text-white text-xs font-semibold hover:bg-zinc-800 disabled:opacity-60">
            {busy ? "Bezig…" : "Opslaan"}
          </button>
          <button data-testid={`contact-annuleren-${u}`} onClick={() => setOpen(false)} className="text-xs text-zinc-500 hover:text-zinc-800">Annuleren</button>
        </>
      )}
    </div>
  );
}
